@if (isInternal) {
  <section>
    <form class="cell" [formGroup]="form">
      <div class="grid-x">
        <div class="auto cell">
          <label>Note Type:</label>
          <select name="type" formControlName="selectedNoteType" required>
            @for (t of types; track t) {
              <option [value]="t.idNumeric">{{t.text}}</option>
            }
          </select>
          @if (form.get('selectedNoteType')?.isDirty; as noteType) {
            <div class="error-container">
              @if (noteType.errors) {
                <small class="error">Note type is required</small>
              }
            </div>
          }
        </div>
      </div>
      <div class="margin-top outline-container">
        <label>Text:</label>
        <div formControlName="noteText" name="text" [froalaEditor]="froalaOptions"></div>
      </div>
      <div class="text-align-center margin-top">
        <span class="padding-right"><button class="button hollow" (click)="cancel()">Cancel</button></span>
        <span class="padding-left"><button class="button" [disabled]="form.invalid" (click)="save()">Save</button></span>
      </div>
    </form>
  </section>
}
<hr />
@if (activeNote?.fieldId != null) {
  <div class="cell italic">
    Only notes attached to the selected field are displayed below.
  </div>
}
@if (displayed) {
  <section class="cell notes">
    @for (note of displayed; track note) {
      <div class="padding-all margin-top margin-bottom"
        [ngClass]="{ 'private-note': note.noteTypeId < 2, 'public-note': note.noteTypeId >= 2 }">
        <div #replyForm>
          <div class="note-group">
            <div class="notes no-margin">
              @if (displayExpander(note.childNotes)) {
                <div class="float-left">
                  @if (!replyForm.opened) {
                    <button (click)="toggleReply(replyForm)"><svg-icon icon="icon-caret-right" class="small gray"></svg-icon></button>
                  }
                  @if (replyForm.opened) {
                    <button (click)="toggleReply(replyForm)"><svg-icon icon="icon-caret-down" class="small gray"></svg-icon></button>
                  }
                </div>
              }
              <div class="note-header default-font">
                <strong>{{note.createdBy}}</strong><span class="float-right">{{ note.createdDate | date: 'MM/d/yyyy | hh:mma' }}</span>
              </div>
              <div [innerHTML]="note.text"></div>
              <div class="childNotes" [ngClass]="{ 'opened': replyForm.opened }">
                @for (childNote of note.childNotes; track childNote) {
                  <div>
                    <hr />
                    <div class="note-header default-font">
                      <strong>{{childNote.createdBy}}</strong><span class="float-right">{{childNote.createdDate | date: 'MM/d/yyyy | hh:mma'}}</span>
                    </div>
                    <div [innerHTML]="childNote.text"></div>
                  </div>
                }
              </div>
            </div>
          </div>
          @if (!replyForm.isReplying) {
            <div class="text-align-right">
              <button (click)="openReplyForm(replyForm)">
                <svg-icon class="cursor-pointer" icon="icon-reply"></svg-icon>
              </button>
            </div>
          }
          @if (replyForm.isReplying) {
            <div>
              <div class="margin-top" [(froalaModel)]="replyForm.replyText" [froalaEditor]="replyFroalaOptions"></div>
              @if (replyForm.isDirty && !replyForm.replyText) {
                <div class="notes errors">
                  <small class="error">Reply text is required</small>
                </div>
              }
              <div class="text-align-center margin-top">
                <span class="minor-margin-right">
                  <button class="button hollow white-background" (click)="resetReplyForm(replyForm)">Cancel</button>
                </span>
                <span class="minor-margin-left">
                  <button class="button" (click)="reply(note, replyForm)">Add Note</button>
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </section>
}